import React, { FC, useState, useMemo } from 'react'
import {
  Box,
  FormControl,
  MenuItem,
  ListSubheader,
  TextField,
  InputAdornment,
  CircularProgress
} from '@mui/material'
import SearchIcon from '@mui/icons-material/Search'

interface AutoCompleterProps {
  item: any[]
  nameList: string
  handleChangeAutoComplete: (event: React.ChangeEvent<HTMLInputElement>) => void
  isLoader: boolean
  inputLabel: string
  width?: number
  height?: number
  margin?: number
  value?: string | number | boolean | string[] | number[]
}

export const AutoCompleterV2: FC<AutoCompleterProps> = ({
  item,
  handleChangeAutoComplete,
  isLoader,
  width = 300,
  height = 300,
  margin = 5,
  value,
  inputLabel,
  nameList
}) => {
  const [selectedOption, setSelectedOption] = useState('')
  const [searchText, setSearchText] = useState('')

  const containsText = (text: any, searchText: any) => {
    return text.toLowerCase().indexOf(searchText.toLowerCase()) > -1
  }

  const displayedOptions = useMemo(
    () => item.filter((option: any) => containsText(option.value, searchText)),
    [searchText, item]
  )

  return (
    <Box
      sx={{ m: margin, width: width, height: height }}
      style={{ maxHeight: '300px' }}
      id='search-select3'
    >
      <FormControl fullWidth style={{ maxHeight: '300px' }} id='search-select2'>
        <TextField
          // Disables auto focus on MenuItems and allows TextField to be in focus
          select
          id='search-select1'
          value={selectedOption}
          onChange={(e: any) => {
            setSelectedOption(e.target.value)
            handleChangeAutoComplete(e)
          }}
          // This prevents rendering empty string in Select's value
          // if search text would exclude currently selected option.
          variant='outlined'
          label={inputLabel}
          autoComplete='off'
          onMouseDown={(e: any) => {
            e.target.value = ''
          }}
          name={`${nameList}`}
          style={{ maxHeight: '300px' }}
        >
          {/* TextField is put into ListSubheader so that it doesn't
              act as a selectable item in the menu
              i.e. we can click the TextField without triggering any selection.*/}
          <ListSubheader style={{ maxHeight: '300px' }} id='search-select5'>
            <TextField
              size='small'
              autoComplete='off'
              // Autofocus on textfield
              autoFocus
              placeholder='Buscar...'
              fullWidth
              InputProps={{
                endAdornment: isLoader ? (
                  <CircularProgress
                    size={20}
                    style={{ marginTop: '5px', marginLeft: '5px' }}
                  />
                ) : (
                  <InputAdornment position='start'>
                    <SearchIcon />
                  </InputAdornment>
                )
              }}
              onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                setSearchText(e.target.value)
                handleChangeAutoComplete(e)
              }}
              onKeyDown={(e) => {
                if (e.key !== 'Escape') {
                  // Prevents autoselecting item while typing (default Select behaviour)
                  e.stopPropagation()
                }
              }}
              value={value}
              name={`${nameList}`}
              inputProps={{
                form: {
                  autocomplete: 'off'
                }
              }}
              style={{ maxHeight: '300px' }}
              id='search-select4'
            />
          </ListSubheader>
          {displayedOptions.length > 0 &&
            displayedOptions.map((option, i) => (
              <MenuItem key={i} value={option.value} id='search-select6'>
                {option.value}
              </MenuItem>
            ))}
        </TextField>
      </FormControl>
    </Box>
  )
}
